import { Query } from '../../models/analytics-api/query.model';
import { Dimension } from '../../models/analytics-api/schema.model';
import { Slice } from '../../models/analytics-api/query_result.model';

export class Match {
  constructor(readonly slice: string, readonly value: string, readonly slices: any[]) {}

  toJson() {
    return {
      slice: this.slice,
      value: this.value
    }
  }
}

export class SearchResult {
  readonly matches: Match[]
  readonly partial: boolean

  constructor(private readonly query: Query, rawResult) {
    const schema = query.schema
    const dimension = schema.fetchDimension(rawResult['dimension'])
    this.matches = this.parseMatches(dimension, rawResult['matches'])
    this.partial = rawResult['partial']
  }

  private parseMatches(dimension, rawMatches): Match[] {
    return rawMatches.map(rawMatch => {
      const match = rawMatch['match']
      const slices = rawMatch['slices']
      const slice = slices[0]['slice'][dimension.name]
      return new Match(slice, match, slices)
    })
  }
}
